import Joi from 'joi'

export const feedbackSchema = Joi.object({
  headerText: Joi.string().max(30).required().messages({
    'string.empty': `Heading cannot be an empty field`,
    'any.required': `Heading is a required field`,
  }),
  subHeaderText: Joi.string().max(100).required().messages({
    'string.empty': `Subheader cannot be an empty field`,
    'any.required': `Subheader is a required field`,
    'string.max': `Subheader length must be less than or equal to 100 characters long`,
  }),
  submitText: Joi.string().max(100).required().messages({
    'string.empty': `Submit Text cannot be an empty field`,
    'any.required': `Submit Text is a required field`,
    'string.max': `Submit Text length must be less than or equal to 100 characters long`,
  }),
  submitMsg: Joi.string().max(100).required().messages({
    'string.empty': `Submit Message cannot be an empty field`,
    'any.required': `Submit Message is a required field`,
    'string.max': `Submit Message length must be less than or equal to 100 characters long`,
  }),
  allowFields: Joi.any(),
  captcha: Joi.boolean(),
  attachments: Joi.boolean(),
  mailboxId: Joi.any().required(),
})
